import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess1300VertragswechselStatus: 'idle',
    startProcess1300VertragswechselError: undefined as any,
    loadUserParamsProcess1300VertragswechselStatus: 'idle',
    loadUserParamsProcess1300VertragswechselError: undefined as any,
    stammIni_VertragswechselFeldKeinRestantAktivStatus: 'idle',
    stammIni_VertragswechselFeldKeinRestantAktivError: undefined as any,
    stammIni_VertragsmanagementNeuvermAbrEditierbarStatus: 'idle',
    stammIni_VertragsmanagementNeuvermAbrEditierbarError: undefined as any,

    process1300VertragswechselList: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    stammIni_VertragsmanagementNeuvermAbrEditierbar: undefined as any,
    stammIni_VertragswechselFeldKeinRestantAktiv: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess1300Vertragswechsel = createAsyncThunk('process1300VertragswechselSlice/startProcess1300Vertragswechsel', async ({ process1300Vertragswechsel }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess1300Vertragswechsel/`,
        prepareData(process1300Vertragswechsel),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess1300VertragswechselStatus } = getState().process1300VertragswechselSlice
        return startProcess1300VertragswechselStatus !== 'pending'
    }
})

export const loadUserParamsProcess1300Vertragswechsel = createAsyncThunk('process1300VertragswechselSlice/loadUserParamsProcess1300Vertragswechsel', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess1300Vertragswechsel/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess1300VertragswechselStatus } = getState().process1300VertragswechselSlice
        return loadUserParamsProcess1300VertragswechselStatus !== 'pending'
    }
})

export const stammIni_VertragswechselFeldKeinRestantAktiv = createAsyncThunk('process1300VertragswechselSlice/stammIni_VertragswechselFeldKeinRestantAktiv', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/StammIni_VertragswechselFeldKeinRestantAktiv/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { stammIni_VertragswechselFeldKeinRestantAktivStatus } = getState().process1300VertragswechselSlice
        return stammIni_VertragswechselFeldKeinRestantAktivStatus !== 'pending'
    }
})

export const stammIni_VertragsmanagementNeuvermAbrEditierbar = createAsyncThunk('process1300VertragswechselSlice/stammIni_VertragsmanagementNeuvermAbrEditierbar', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/StammIni_VertragsmanagementNeuvermAbrEditierbar/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { stammIni_VertragsmanagementNeuvermAbrEditierbarStatus } = getState().process1300VertragswechselSlice
        return stammIni_VertragsmanagementNeuvermAbrEditierbarStatus !== 'pending'
    }
})

const Process1300VertragswechselSlice = createSlice({
    name: 'process1300VertragswechselSlice',
    initialState,
    reducers: {
        resetstartProcess1300Vertragswechsel: (state) => {
            state.job = undefined
            state.startProcess1300VertragswechselError = undefined
        },
        resetstartProcess1300VertragswechselError: (state) => {
            state.startProcess1300VertragswechselError = undefined
        },
        resetloadUserParamsProcess1300Vertragswechsel: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess1300VertragswechselError = undefined
        },
        resetloadUserParamsProcess1300VertragswechselError: (state) => {
            state.loadUserParamsProcess1300VertragswechselError = undefined
        },
        resetstammIni_VertragswechselFeldKeinRestantAktiv: (state) => {
            state.stammIni_VertragswechselFeldKeinRestantAktiv = undefined
            state.stammIni_VertragswechselFeldKeinRestantAktivError = undefined
        },
        resetstammIni_VertragswechselFeldKeinRestantAktivError: (state) => {
            state.stammIni_VertragswechselFeldKeinRestantAktivError = undefined
        },
        resetstammIni_VertragsmanagementNeuvermAbrEditierbar: (state) => {
            state.stammIni_VertragsmanagementNeuvermAbrEditierbar = undefined
            state.stammIni_VertragsmanagementNeuvermAbrEditierbarError = undefined
        },
        resetstammIni_VertragsmanagementNeuvermAbrEditierbarError: (state) => {
            state.stammIni_VertragsmanagementNeuvermAbrEditierbarError = undefined
        },
        removeFromProcess1300VertragswechselListById: (state, action) => {
            state.process1300VertragswechselList = state.process1300VertragswechselList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess1300VertragswechselListByIds: (state, action) => {
            state.process1300VertragswechselList = state.process1300VertragswechselList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process1300VertragswechselList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess1300VertragswechselStatus = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process1300VertragswechselList = []
            state.startProcess1300VertragswechselStatus = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess1300Vertragswechsel.pending, (state) => {
            state.startProcess1300VertragswechselStatus = 'pending'
            state.startProcess1300VertragswechselError = undefined
        })
        builder.addCase(startProcess1300Vertragswechsel.fulfilled, (state, action) => {
            state.startProcess1300VertragswechselStatus = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess1300Vertragswechsel.rejected, (state, action) => {
            state.startProcess1300VertragswechselStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess1300VertragswechselError = action.error.message
            } else {
                state.startProcess1300VertragswechselError = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess1300Vertragswechsel.pending, (state) => {
            state.loadUserParamsProcess1300VertragswechselStatus = 'pending'
            state.loadUserParamsProcess1300VertragswechselError = undefined
        })
        builder.addCase(loadUserParamsProcess1300Vertragswechsel.fulfilled, (state, action) => {
            state.loadUserParamsProcess1300VertragswechselStatus = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess1300Vertragswechsel.rejected, (state, action) => {
            state.loadUserParamsProcess1300VertragswechselStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess1300VertragswechselError = action.error.message
            } else {
                state.loadUserParamsProcess1300VertragswechselError = action.payload
            }
        })

        builder.addCase(stammIni_VertragswechselFeldKeinRestantAktiv.pending, (state) => {
            state.stammIni_VertragswechselFeldKeinRestantAktivStatus = 'pending'
            state.stammIni_VertragswechselFeldKeinRestantAktivError = undefined
        })
        builder.addCase(stammIni_VertragswechselFeldKeinRestantAktiv.fulfilled, (state, action) => {
            state.stammIni_VertragswechselFeldKeinRestantAktivStatus = 'idle'

            {
                state.stammIni_VertragswechselFeldKeinRestantAktiv = action.payload

            }
        })
        builder.addCase(stammIni_VertragswechselFeldKeinRestantAktiv.rejected, (state, action) => {
            state.stammIni_VertragswechselFeldKeinRestantAktivStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.stammIni_VertragswechselFeldKeinRestantAktivError = action.error.message
            } else {
                state.stammIni_VertragswechselFeldKeinRestantAktivError = action.payload
            }
        })

        builder.addCase(stammIni_VertragsmanagementNeuvermAbrEditierbar.pending, (state) => {
            state.stammIni_VertragsmanagementNeuvermAbrEditierbarStatus = 'pending'
            state.stammIni_VertragsmanagementNeuvermAbrEditierbarError = undefined
        })
        builder.addCase(stammIni_VertragsmanagementNeuvermAbrEditierbar.fulfilled, (state, action) => {
            state.stammIni_VertragsmanagementNeuvermAbrEditierbarStatus = 'idle'

            {
                state.stammIni_VertragsmanagementNeuvermAbrEditierbar = action.payload

            }
        })
        builder.addCase(stammIni_VertragsmanagementNeuvermAbrEditierbar.rejected, (state, action) => {
            state.stammIni_VertragsmanagementNeuvermAbrEditierbarStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.stammIni_VertragsmanagementNeuvermAbrEditierbarError = action.error.message
            } else {
                state.stammIni_VertragsmanagementNeuvermAbrEditierbarError = action.payload
            }
        })

    }
})

export const {
    resetstartProcess1300Vertragswechsel,
    resetstartProcess1300VertragswechselError,
    resetloadUserParamsProcess1300Vertragswechsel,
    resetloadUserParamsProcess1300VertragswechselError,
    resetstammIni_VertragswechselFeldKeinRestantAktiv,
    resetstammIni_VertragswechselFeldKeinRestantAktivError,
    resetstammIni_VertragsmanagementNeuvermAbrEditierbar,
    resetstammIni_VertragsmanagementNeuvermAbrEditierbarError,
    removeFromProcess1300VertragswechselListById,
    removeFromProcess1300VertragswechselListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process1300VertragswechselSlice.actions
export default Process1300VertragswechselSlice.reducer
